import { useContext } from 'react'
import { utils } from '@digital-commerce/shared-utils'
import { object } from 'prop-types'
import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'
import PriceBreakdownContainer from '../../molecules/CartItem/PriceBreakdown/PriceBreakdownContainer'
import { buildRecurringTermDiscount } from './utils'
import NameAndPrice from '../../atoms/ItemDetails/NameAndPrice'
import FinalPrice from '../../molecules/CartItem/PriceBreakdown/FinalPrice'
import { formatCurrency } from '../../../utils/currency'

const { getMonthlyTotalPrice, getDisplayName } = utils.cart

const OfferDetails = ({ gift }) => {
  const { lang } = useContext(localeContext)
  const translate = useTranslate()
  const { amount, total: finalPrice } = getMonthlyTotalPrice(gift)
  const termDiscountData = buildRecurringTermDiscount(gift, translate, lang)
  const recurringTermDiscount = termDiscountData && (
    <NameAndPrice
      id={termDiscountData.id}
      key={termDiscountData.id}
      name={termDiscountData.name}
      price={termDiscountData.price}
      prefixIcon={termDiscountData.prefixIcon}
    />
  )

  const itemPrice = (
    <NameAndPrice id={gift.id} name={getDisplayName(gift)} price={formatCurrency(amount, lang)} />
  )

  return (
    <PriceBreakdownContainer>
      {itemPrice}
      {recurringTermDiscount}
      <FinalPrice price={finalPrice} isMonthly />
    </PriceBreakdownContainer>
  )
}

export default OfferDetails

OfferDetails.propTypes = {
  gift: object.isRequired
}
